import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    header: {
      padding: spacing(1, 0, 1, 5),
    },
  })
);
